import React from "react";
import BriefProjectsPreview from "../BriefProjectsPreview";

export default function BriefCardsProto() {
  return <BriefProjectsPreview />;
}
